module.exports = __webpack_public_path__ + "static/media/Ask_Me_Screen.2e05a3ae.png";